import * as React from 'react';
import { Fieldset, Control, Errors} from 'react-redux-form';
import { PersonModel } from '../models/CommonModels';
import FormItem from '../../components/forms/FormItem';
import { renderNewTextField, renderErrorInfoText } from './FieldCreators';
import { localizations } from '../../localization/localization';
import nameof from '../../utils/nameof';
import * as validators from '../validators/formValidators'

export const FirstLastNameFormGroup = ({ modelBase }: any) => {
    return <Fieldset model={`${modelBase}`}>
        <FormItem>
            <Control required validators={{required: validators.required}} model={`.${nameof<PersonModel>("firstName")}`} label={localizations.common.firstName} component={renderNewTextField} />
            <Errors model={`.${nameof("firstName")}`} show={{touched: true, focus: false}} messages={{required: localizations.validation.required}} wrapper={renderErrorInfoText} />
        </FormItem>
        <FormItem>
            <Control required validators={{required: validators.required}}  model={`.${nameof<PersonModel>("lastName")}`} label={localizations.common.lastName} component={renderNewTextField} />
            <Errors model={`.${nameof("lastName")}`} show={{touched: true, focus: false}} messages={{required: localizations.validation.required}} wrapper={renderErrorInfoText} />
        </FormItem>
    </Fieldset>
}


// WEBPACK FOOTER //
// ./src/common/forms/PersonFormGroup.tsx